var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.50001C13 3.74853 12.6437 3.95001 12.2041 3.95001L2.8791 3.95001L6.36744 5.71464C6.69503 5.88036 6.72299 6.16484 6.42989 6.35005C6.13678 6.53527 5.63361 6.55107 5.30602 6.38535L0.265201 3.83537C0.0964651 3.75 0 3.62803 0 3.50001C0 3.37198 0.0964651 3.25001 0.265201 3.16465L5.30602 0.614658C5.63361 0.448938 6.13678 0.464718 6.42989 0.649938C6.72299 0.835157 6.69503 1.11968 6.36744 1.2854L2.8791 3.05001L12.2041 3.05001C12.6437 3.05001 13 3.25148 13 3.50001Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left-arrow-icon.edf42bdb985b6eb19e69f420ab2fa1c2.svg";
export { ForwardRef as ReactComponent };